module.exports = __webpack_public_path__ + "img/foto-henrique-ravanelli.jpg";